import { useEffect, useState } from "react";
import API from "../api/api";
import { Link } from "react-router-dom";
import "./Dashboard.css";

const icons = {
    members: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>,
    donations: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78-.77-.78a5.4 5.4 0 0 0-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z"></path></svg>,
    events: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>,
    sponsors: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>,
    messages: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
};

function Dashboard() {
    const [stats, setStats] = useState({
        memberships: 0,
        donations: 0,
        events: 0,
        sponsors: 0,
        messages: 0
    });

    useEffect(() => {
        API.get("/dashboard/stats")
            .then(res => setStats(res.data))
            .catch(err => console.error("Error fetching stats:", err));
    }, []);

    const adminEmail = localStorage.getItem("email") || "Admin";

    return (
        <div className="dashboard-container">
            {/* Background Decorations */}
            <div className="blob blob-1"></div>
            <div className="blob blob-2"></div>

            {/* Hero Welcome Section */}
            <div className="welcome-banner animate-fade-in">
                <div className="welcome-content">
                    <h1>Welcome back, {adminEmail.split('@')[0]}! 👋</h1>
                    <p>Here's what's happening in the community today. Your dashboard is up to date.</p>
                </div>
                <div className="welcome-visual">
                    {/* Abstract SVG or decorative element */}
                    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="60" cy="60" r="60" fill="url(#paint0_linear_101_2)" fillOpacity="0.2" />
                        <circle cx="60" cy="60" r="40" fill="url(#paint0_linear_101_2)" fillOpacity="0.4" />
                        <defs>
                            <linearGradient id="paint0_linear_101_2" x1="0" y1="0" x2="120" y2="120" gradientUnits="userSpaceOnUse">
                                <stop stopColor="white" />
                                <stop offset="1" stopColor="white" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
            </div>

            {/* Stats Grid */}
            <div className="stats-grid">
                <div className="stat-card glass animate-fade-in" style={{ animationDelay: "0.1s" }}>
                    <div className="card-inner">
                        <div className="icon-wrapper" style={{ '--bg': 'rgba(99, 102, 241, 0.15)', '--color': '#6366f1' }}>
                            {icons.members}
                        </div>
                        <div className="card-info">
                            <span className="card-label">Members</span>
                            <div className="card-value">{stats.memberships}</div>
                        </div>
                    </div>
                </div>

                <div className="stat-card glass animate-fade-in" style={{ animationDelay: "0.2s" }}>
                    <div className="card-inner">
                        <div className="icon-wrapper" style={{ '--bg': 'rgba(16, 185, 129, 0.15)', '--color': '#10b981' }}>
                            {icons.donations}
                        </div>
                        <div className="card-info">
                            <span className="card-label">Donations</span>
                            <div className="card-value">{stats.donations}</div>
                        </div>
                    </div>
                </div>

                <div className="stat-card glass animate-fade-in" style={{ animationDelay: "0.3s" }}>
                    <div className="card-inner">
                        <div className="icon-wrapper" style={{ '--bg': 'rgba(245, 158, 11, 0.15)', '--color': '#f59e0b' }}>
                            {icons.events}
                        </div>
                        <div className="card-info">
                            <span className="card-label">Events</span>
                            <div className="card-value">{stats.events}</div>
                        </div>
                    </div>
                </div>

                <div className="stat-card glass animate-fade-in" style={{ animationDelay: "0.4s" }}>
                    <div className="card-inner">
                        <div className="icon-wrapper" style={{ '--bg': 'rgba(139, 92, 246, 0.15)', '--color': '#8b5cf6' }}>
                            {icons.sponsors}
                        </div>
                        <div className="card-info">
                            <span className="card-label">Sponsors</span>
                            <div className="card-value">{stats.sponsors}</div>
                        </div>
                    </div>
                </div>

                <div className="stat-card glass animate-fade-in" style={{ animationDelay: "0.5s" }}>
                    <div className="card-inner">
                        <div className="icon-wrapper" style={{ '--bg': 'rgba(236, 72, 153, 0.15)', '--color': '#ec4899' }}>
                            {icons.messages}
                        </div>
                        <div className="card-info">
                            <span className="card-label">Messages</span>
                            <div className="card-value">{stats.messages}</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Quick Actions */}
            <div className="actions-section animate-fade-in" style={{ animationDelay: "0.6s" }}>
                <div className="section-header">
                    <h2>Quick Management</h2>
                    <div className="header-line"></div>
                </div>

                <div className="floating-actions">
                    <Link to="/events" className="glass-action-btn">
                        <div className="btn-icon">{icons.events}</div>
                        <div className="btn-text">
                            <strong>Create Event</strong>
                            <span>Organize new activity</span>
                        </div>
                    </Link>
                    <Link to="/sponsors" className="glass-action-btn">
                        <div className="btn-icon">{icons.sponsors}</div>
                        <div className="btn-text">
                            <strong>Add Sponsor</strong>
                            <span>Grow community support</span>
                        </div>
                    </Link>
                    <Link to="/committee" className="glass-action-btn">
                        <div className="btn-icon">{icons.members}</div>
                        <div className="btn-text">
                            <strong>Add Committee</strong>
                            <span>Update team members</span>
                        </div>
                    </Link>
                    <Link to="/memberships" className="glass-action-btn">
                        <div className="btn-icon">{icons.members}</div>
                        <div className="btn-text">
                            <strong>Memberships</strong>
                            <span>Review applications</span>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;